import { useSyncExternalStore } from "react";

const subscribeToPasskeySupport = () => () => undefined;

const getPasskeySupportSnapshot = () =>
  typeof window !== "undefined" && Boolean(window.PublicKeyCredential);

export function usePasskeySupport() {
  return useSyncExternalStore(
    subscribeToPasskeySupport,
    getPasskeySupportSnapshot,
    () => false,
  );
}
